import { useCallback } from "react";
import {
  useModal,
  ReApproveConfirmationModalContent,
} from "../../../components/Modal";

const REAPPROVE_MODAL_ID = "reapprove-confirmation-modal";

export function useTreatmentPlanReApprove() {
  const { openModal, closeModal, updateModal } = useModal();

  const openReApproveConfirmation = useCallback(
    (onReApprove: () => Promise<void>) => {
      openModal({
        id: REAPPROVE_MODAL_ID,
        title: "",
        content: (
          <ReApproveConfirmationModalContent
            onClose={() => closeModal(REAPPROVE_MODAL_ID)}
            onReApprove={async () => {
              await onReApprove();
              closeModal(REAPPROVE_MODAL_ID);
            }}
            onLoadingChange={(loading) =>
              updateModal(REAPPROVE_MODAL_ID, {
                closeOnBackdropClick: !loading,
              })
            }
          />
        ),
        showCloseButton: false,
        closeOnBackdropClick: true,
        maxWidth: "600px",
        containerPadding: "60px 90px",
        contentPadding: "0",
      });
    },
    [closeModal, openModal, updateModal],
  );

  return { openReApproveConfirmation };
}
